import angular from 'angular';
import TopSellingGamesWidgetComponent from './top-selling-games-widget-component';

export default angular.module('top-selling-games-widget', []).component('topSellingGamesWidget', new TopSellingGamesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/top-selling-games/top-selling-games-widget-module.js